import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LoadContainers_ds_get_shipment_load_containersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { load_container_id?: number }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_shipment_load_containers/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { load_container_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_shipment_load_containers/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { load_container_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_shipment_load_containers/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
